import { BringToFrontCommand } from './bring-to-front-command';

export class SendToBackCommand extends BringToFrontCommand {

  execute () {
    this.layer.sendFeaturesToBack(this.features);
  }

}
